module.exports = __webpack_public_path__ + "assets/images/project/satellite-gifs/nongsa.gif?v=ea994c10";